import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=0c03e61e&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=0c03e61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03e61e",
  null
  
)

export default component.exports